import { render, staticRenderFns } from "./serverManageList.vue?vue&type=template&id=0604f778&"
import script from "./serverManageList.vue?vue&type=script&lang=js&"
export * from "./serverManageList.vue?vue&type=script&lang=js&"
import style0 from "./serverManageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0604f778')) {
      api.createRecord('0604f778', component.options)
    } else {
      api.reload('0604f778', component.options)
    }
    module.hot.accept("./serverManageList.vue?vue&type=template&id=0604f778&", function () {
      api.rerender('0604f778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/serverManagement/serverManageList.vue"
export default component.exports